import React, { memo, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function CollapsedPolyCountRow() {
  const t = useTranslation()
  const isDisabled = useThreeDStudioStore(state => {
    const uiSchema = state.schema.generationModelSchema.ui_schema || {}
    const { face_count: faceCountSchema, target_polycount: targetPolycountSchema } = uiSchema || {}

    return faceCountSchema?.['ui:options']?.disabled || targetPolycountSchema?.['ui:options']?.disabled
  })
  const targetPolycount = useThreeDStudioStore(state => state.modelSettings.targetPolycount)
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const faceCountSchema = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.input_schema?.properties?.face_count,
  )
  const targetPolycountSchema = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.input_schema?.properties?.target_polycount,
  )

  const polyCountSchema = useMemo(() => {
    const schema = faceCountSchema || targetPolycountSchema
    const schemaKey = faceCountSchema ? 'face_count' : 'target_polycount'

    if (schema?.oneOf) {
      const matched = schema.oneOf.find(
        entry => entry?.if?.properties?.polygon_type?.const === polygonType,
      )

      if (matched) {
        return matched?.then?.properties?.[schemaKey]
      }
    }

    return schema
  }, [faceCountSchema, targetPolycountSchema, polygonType])

  const { minimum, default: defaultValue, maximum } = polyCountSchema || {}

  let presetLabel
  if (targetPolycount === minimum) {
    presetLabel = t('leftSide.polyCount.low')
  } else if (targetPolycount === defaultValue) {
    presetLabel = t('leftSide.polyCount.medium')
  } else if (targetPolycount === maximum) {
    presetLabel = t('leftSide.polyCount.high')
  }

  if (presetLabel) {
    return (
      <ClosedButtonSettings
        label={t('leftSide.polyCount.label')}
        isActive
        disabled={isDisabled}
        buttonLabel={presetLabel}
      />
    )
  }

  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{t('leftSide.polyCount.label')}</span>
      <span className="collapsed-model-settings__numeric-value cgt-body-base">
        {targetPolycount}
      </span>
    </div>
  )
}

export default memo(CollapsedPolyCountRow)
